import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";
import { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import historyIcon from "../../../assets/images/history-icon.svg";
import FormButton from "../../../Components/Buttons/FormButton";
import Loader from "../../../Components/GlobalLoader/Loader";
import DynamicDetailGrid from "../../../Components/Grid/DynamicDetailGrid";
import ViewMoreModal from "../../../Components/Modals/ViewMoreModal";
import Table, { Column } from "../../../Components/Tables/Table";
import {
  HistoryLaoutDataOutBoundOverviewDetail,
} from "../../../Data/outbound";
import HistoryLayout from "../../../Layout/HistoryLaout";
import PageHeader from "../../../Layout/PageHeader";
import { formatDate, formatNumber } from "../../../Utility/Utility";
import PageInProgress from "../../WildCardPages/PageInProgress";
import { OrderLine, SalesOrder } from "./model/orderDetails.model";
import { getByOrderId } from "./service/orderOverview.service";

export default function OutboundDetails() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [orderData, setOrderData] = useState<SalesOrder | null>(null);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      if(!id){
          return;
      }
      try {
        setIsLoading(true);
        const response = await getByOrderId(id);
        console.log(response);
        setOrderData(response.data);
      } catch (error) {
        console.error("Error fetching order details:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (id) {
      fetchOrderDetails();
    }
  }, [id]);

  const [collapseStates, setCollapseStates] = useState<boolean[]>([false]);
  const toggleCollapse = (index: number) => {
    const updatedCollapseStates = [...collapseStates];
    updatedCollapseStates[index] = !updatedCollapseStates[index];
    setCollapseStates(updatedCollapseStates);
  };
  const [isShowCanvas, setShowCanvas] = useState(false);
  const handelCanvas = () => {
    setShowCanvas(!isShowCanvas);
  };
  const handelPickDetailClick = () => {
    navigate(`/outbound/orders/order-pick-details/${id}`);
  };
  const handelShipDetailClick = () => {
    navigate(`/outbound/orders/order-shipment-details/${id}`);
  };

  const viewText = "Handle lorem with care dummy text of the printing and typesetting industry. Lorem Ipsum lorem Ipsum ."
  const [showViewModal, setViewModal] = useState(false);
  const handelViewMoreAction = (data: any) => {
    setViewModal(true);
  };

  const handleViewClose = () => setViewModal(false);
  const onModalSubmit = () => {
    handleViewClose();
  };
  const historyData = (
    <div
      className="d-flex justify-content-between w-100 align-items-center px-4"
      onClick={handelCanvas}
    >
      <div>
        <h6 className="cursor-pointer m-0 d-flex align-items-center">
          <img src={historyIcon} className="me-2" alt="no image" />
          History
        </h6>
      </div>
    </div>
  );

  const columns: Column[] = [
    {
      name: "Line #",
      selector: (row: OrderLine) => row.line_number.toString(),
    },
    {
      name: "Item Code",
      selector: (row: OrderLine) =>  row.item.code,
    },
    {
      name: "Item Name",
      selector: (row: OrderLine) => (
        <span
          title={row.item.name.length > 15 ? row.item.name : ""}
        >
          {row.item.name.length > 15
            ? `${row.item.name.slice(0, 15)}...`
            : row.item.name}
        </span>
      ),
    },
    {
      name: "Shipping UOM",
      selector: (row: OrderLine) => row.uom_code,
    },
    {
      name: "Ordered Qty",
      selector: (row: OrderLine) => formatNumber(row.qty_ordered),
    },
    {
      name: "Shipment Qty",
      selector: (row: OrderLine) => formatNumber(row.qty_shipped),
    }
  ];

  const getOrderDetailsData = () => {
    if (!orderData) return {
      OutboundDetailsExpanded: [],
      OutboundDetailsDefault: []
    };

    return {
      OutboundDetailsExpanded: [
        { label: "Client", value: `${orderData?.client?.name}(${orderData?.client?.code})` },
        { label: "Customer Code", value: orderData.customer?.code || "-" },
        { label: "Ship-to Code", value: orderData.customer_ship_to?.code || "-" },
        { label: "Bill-to Code", value: orderData.customer_bill_to?.code || "-" },
        { label: "Ship-to Name", value: <>{orderData.ship_to_name || "-"}</> },
        { label: "Contact Name", value: orderData.contact_name || "-" },
        { label: "Phone Number", value: orderData?.contact_phone || "-" },
        { label: "Address 1", value: orderData?.address_line_1 || "-" },
        { label: "Address 2", value: <>{orderData?.address_line_2 || "-"}</> },
        { label: "City", value: orderData?.city || "-" },
        { label: "State", value: orderData?.state_province || "-" },
        { label: "Zip/Postal Code", value: orderData?.postal_code || "-" },
        { label: "Country", value: orderData.country?.name || "-" },
        {
          label: "Shipments",
          value: (
            <a
              className="cursor-pointer font-size-15 d-flex gap-1 align-items-center text-decoration-none order-redirect-btn px-1 fc-dark-blue"
              onClick={handelShipDetailClick}
            >           
              0
              {/* {GetSvgIcon.RedirectIcon} */}
            </a>
          ),
        },
        {
          label: "Pick Ticket #",
          value: (
            <a
              className="cursor-pointer font-size-15 d-flex gap-1 align-items-center text-decoration-none order-redirect-btn px-1 fc-dark-blue"
              onClick={handelPickDetailClick}
            >
              0
              {/* {GetSvgIcon.RedirectIcon} */}
            </a>
          ),
        },
        {
          label: "Status",
          value: (
              <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                {orderData.statusLookup?.description || "New"}
              </div>
          ),
        },
      ],

      OutboundDetailsDefault: [
        { label: "Ship-to Code", value: orderData.customer_ship_to?.code || "-" },
        { label: "Bill-to Code", value: orderData.customer_bill_to?.code || "-" },
        {
          label: "Status",
          value: (
              <div className="text-dark w-auto px-4 badge asn-overview-status w-70 asn-overview-status-border-blue">
                {orderData.statusLookup?.description || "New"}
              </div>
          ),
        },
      ],
    };
  };

  const getOrderDetailsData2 = () => {
    if (!orderData) return {
      OutboundDetailsExpanded2: [],
      OutboundDetailsDefault2: []
    };


    return {
      OutboundDetailsExpanded2: [
        { label: "Order Date", value: formatDate(orderData.order_date) },
        { label: "Ship-by Date", value: formatDate(orderData.ship_by_date) },
        { label: "Carrier Level", value: "-" },
        { label: "Service Level", value: "-" },
        { label: "Customer Sales Order", value: orderData.customer_order_number },
        { label: "Customer Purchase Order", value: orderData.customer_po_number },
        {
          label: "Notes",
          value: (
            <>
            {
              orderData.notes_1 && orderData.notes_1.length > 25 
                ? `${orderData.notes_1.substring(0, 25)}...` 
                : orderData.notes_1 || "-"
            }

            {orderData.notes_1 && orderData.notes_1.length > 25 && (
              <div>
                {"("} 
                <span className="text-primary cursor-pointer"
                onClick={() => handelViewMoreAction(orderData.notes_1)}
                >View More</span>
                {")"}
              </div>
            )}
            </>
          )
        },
        { label: "Special Instructions", value: (
          <>
          {
            orderData.special_instructions && orderData.special_instructions.length > 25 
              ? `${orderData.special_instructions.substring(0, 25)}...` 
              : orderData.special_instructions || "-"
          }

          {orderData.special_instructions && orderData.special_instructions.length > 25 && (
            <div>
              {"("} 
              <span className="text-primary cursor-pointer"  
              onClick={() => handelViewMoreAction(orderData.special_instructions)}
              >View More</span>
              {")"}
            </div>
          )}
          </>
        ) },
      ],

      OutboundDetailsDefault2: [
        { label: "Order Date", value: formatDate(orderData.order_date) },
        { label: "Ship-by Date", value: formatDate(orderData.ship_by_date) },
      ],
    };
  };



  if (isLoading) {
    return <Loader />;
  }

  const OutbounDetailsData = getOrderDetailsData();
  const OutbounDetailsData2 = getOrderDetailsData2();

  return orderData ?(
    <>
      <Toaster/>
      <PageHeader
        listUrl="/outbound/orders"
        viewType={true}
        isHistoryEnabled={true}
        historyData={[historyData]}
      />
      <h5 className="text-start mt-1 mb-3">{`Order(${orderData.order_number})`}</h5>

      <div className="my-2 bg-white rounded py-1 px-2 d-flex flex-column">
        <div className="checkin-details col-12 bg-white col-12 py-1  px-2 ">
          {collapseStates[0] ? (
             <div className="checkin-details row align-items-center d-flex bg-white col-12">
             <DynamicDetailGrid
               customClassName="my-2 col-6 border-end"
               isExpandable={false}
               columns={3}
               data={OutbounDetailsData.OutboundDetailsDefault}
             />
             <DynamicDetailGrid
               customClassName="my-2 col-5 ps-5"
               isExpandable={false}
               columns={2}
               data={OutbounDetailsData2.OutboundDetailsDefault2}
             />
             <div className="col-1">
               <div className="align-self-center d-flex flex-row-reverse mt-1 mb-5">
                 <span
                   className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6 mb-5"
                   onClick={() => toggleCollapse(0)}
                 >
                   {collapseStates[0] ? <ChevronDown /> : <ChevronUp />}
                 </span>
               </div>
             </div>
           </div>
          ) : (
            <div className="checkin-details row align-items-top d-flex bg-white col-12 ">
            <DynamicDetailGrid
              customClassName="my-2 col-6 border-end"
              isExpandable={false}
              columns={3}
              data={OutbounDetailsData.OutboundDetailsExpanded}
            />
            <DynamicDetailGrid
              customClassName="my-2 col-5 ps-5"
              isExpandable={false}
              columns={2}
              data={OutbounDetailsData2.OutboundDetailsExpanded2}
            />

            <div className="col-1">
              <div className="align-self-center d-flex flex-row-reverse my-1">
                <span
                  className="badge rounded-pill sph-text-bg-light-grey cursor-pointer fs-6"
                  onClick={() => toggleCollapse(0)}
                >
                  {collapseStates[0] ? <ChevronDown /> : <ChevronUp />}
                </span>
              </div>
            </div>
          </div>
          )}
        </div>
      </div>

      <div className="mt-2 bg-white rounded py-1 px-4 detail-table-scroll">
        <Table
          columns={columns}
          data={orderData?.lines?? []}
          CheckboxStatus={false}
          isStripped={true}
          customClassName="transferDetailsTable"
        />
      </div>
      <div className="mt-auto bg-white rounded py-3">
        <div className="d-flex flex-row-reverse">
          <FormButton
            tabIndex={11}
            className="sph-btn me-4"
            handleClick={() => {
              navigate(`/outbound/orders/edit/${id}`);
            }}
          >
            Edit
          </FormButton>
        </div>
      </div>
      <HistoryLayout
        isShowCanvas={isShowCanvas}
        handelCanvas={handelCanvas}
        data={HistoryLaoutDataOutBoundOverviewDetail}
      />

      <ViewMoreModal
        customClassName="header-border"
        show={showViewModal}
        content={orderData?.notes_1 || viewText}
        onModalSubmit={onModalSubmit}
      />
    </>
  ):<PageInProgress/>;
}
